import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import { PageHero } from "@/components/sections/PageHero";

export default function About() {
  return (
    <>
      <Header />
      <main>
        <PageHero title="About Us" breadcrumb="About" />
        
        <section className="py-[80px] bg-white">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <div className="flex flex-col lg:flex-row items-start gap-[60px]">
              <div className="w-full lg:w-1/2">
                <img
                  src="/images/logo-about.bmp"
                  alt="Basupra Exim Logo"
                  className="w-full max-w-[400px] mx-auto h-auto object-contain"
                />
              </div>
              
              <div className="w-full lg:w-1/2 space-y-6">
                <h2 className="font-display font-bold text-[28px] text-[#001d3d] leading-[1.3]">
                  Welcome to Basupra Exim International
                </h2>
                
                <p className="text-[#4a5568] text-[16px] leading-[1.8]">
                  M/s. BasupraEXIM International is a company that focuses mainly on specially designed and developed turnkey projects in the fields of food processing, agro-processing, and engineering.
                </p>
                
                <p className="text-[#4a5568] text-[16px] leading-[1.8]">
                  As per the requirement of end customers abroad, we do undertake total turn-key projects which involve market survey, design of the project, layout, manufacture, installation, erection, and commissioning with a satisfactory trial on a needful basis.
                </p>
                
                <p className="text-[#4a5568] text-[16px] leading-[1.8]">
                  Further, we also provide full backup for technology, managerial, and marketing aspect along with extension programs. Our company has experience of foreign business, technical and managerial sound knowledge to establish above units in abroad.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-[#f8f9fa]">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <h2 className="font-display font-bold text-[28px] text-[#001d3d] text-center mb-[50px] uppercase tracking-wider">
              Our Capabilities
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-card">
                <h3 className="font-display font-bold text-[20px] text-[#001d3d] mb-4">Manufacturing</h3>
                <p className="text-[#4a5568] text-[15px] leading-[1.7]">
                  In part of manufacturing our company manufactures major equipment and types of machinery, assemble at our factory site, and other ready equipment manufactured on a subcontract basis, as per our design and requirement.
                </p>
              </div>
              
              <div className="bg-white p-8 rounded-lg shadow-card">
                <h3 className="font-display font-bold text-[20px] text-[#001d3d] mb-4">Design & Engineering</h3>
                <p className="text-[#4a5568] text-[15px] leading-[1.7]">
                  We will provide design, drawing, and raw materials as per customer requirements. Our technical team ensures precision in every project we undertake.
                </p>
              </div>
              
              <div className="bg-white p-8 rounded-lg shadow-card">
                <h3 className="font-display font-bold text-[20px] text-[#001d3d] mb-4">Global Reach</h3>
                <p className="text-[#4a5568] text-[15px] leading-[1.7]">
                  We help people globally to nurture prosperity in agriculture, food and engineering sector with our Indian technologies and expertise.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-white">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <h2 className="font-display font-bold text-[28px] text-[#001d3d] text-center mb-[50px] uppercase tracking-wider">
              Why Choose Us
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#17A2B8] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-[18px]">1</span>
                </div>
                <div>
                  <h4 className="font-display font-bold text-[18px] text-[#001d3d] mb-2">Experience</h4>
                  <p className="text-[#4a5568] text-[15px] leading-[1.7]">Years of experience in foreign business with technical and managerial expertise.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#17A2B8] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-[18px]">2</span>
                </div>
                <div>
                  <h4 className="font-display font-bold text-[18px] text-[#001d3d] mb-2">Quality</h4>
                  <p className="text-[#4a5568] text-[15px] leading-[1.7]">We manufacture excellent quality equipment based on project design requirements.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#17A2B8] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-[18px]">3</span>
                </div>
                <div>
                  <h4 className="font-display font-bold text-[18px] text-[#001d3d] mb-2">Support</h4>
                  <p className="text-[#4a5568] text-[15px] leading-[1.7]">Full backup for technology, managerial, and marketing aspects along with extension programs.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#17A2B8] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-[18px]">4</span>
                </div>
                <div>
                  <h4 className="font-display font-bold text-[18px] text-[#001d3d] mb-2">Turnkey Solutions</h4>
                  <p className="text-[#4a5568] text-[15px] leading-[1.7]">Complete project solutions from market survey to commissioning with satisfactory trials.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
